import { prefixRecordFieldSetNames } from 'Components/Worksheets/Core/WorksheetRecordGrid/helpers';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { getGridFieldSet as getMoistureContentGridFieldSet } from 'Components/Worksheets/MoistureContentWorksheet/Astm/gridFieldSets';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../../../Lib/Object/deepEquals';
import { Checkbox, Field, NumericInput } from '../../../../../Core';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { IWithWorksheetInjectedProps, WorksheetGridFieldSection, WorksheetRecordGrid } from '../../../../Core';

let LiquidLimitMethodATrialSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));

  const trialRecordProps = useSelector(
    pipe(createWorksheetSelector!('Trials'), valueOrDefault([] as Array<any>), (trials) =>
      trials.map((t, i) => ({
        dim: t.ExcludedTrial,
        preventRemove: i < 3,
      }))
    ),
    deepEquals
  );

  return (
    <WorksheetGridFieldSection name="Trials">
      <WorksheetRecordGrid
        name={'Trials'}
        orientation={'horizontal'}
        recordProps={{
          width: 130,
          preventRemove: (i) => trialRecordProps[i]?.preventRemove,
          dim: (i) => trialRecordProps[i]?.dim,
          enforceAtLeastOneRecord: true,
          removeConfirm: {
            confirm: true,
            confirmTitle: 'Trial Deletion',
            confirmText: 'Are you sure you want to delete the selected trial?',
            confirmButtonText: 'Delete Trial',
          },
        }}
        fieldSet={[
          {
            name: 'Drops',
            component: <Field input={<NumericInput />} />,
            label: 'Drops', // Remove when labels migrated to config
          },
          ...prefixRecordFieldSetNames('MoistureDetermination', getMoistureContentGridFieldSet(dryMassEntryOption)),
          {
            name: 'ExcludedTrial',
            component: <Field input={<Checkbox />} />,
            label: 'Exclude Trial', // Remove when labels migrated to config
          },
        ]}
      />
    </WorksheetGridFieldSection>
  );
};

LiquidLimitMethodATrialSection = withInjectedProps(LiquidLimitMethodATrialSection);

export { LiquidLimitMethodATrialSection };
export default LiquidLimitMethodATrialSection;
